module.exports = "//public.zight.com/packs/media/images/icon-clock-8382f3336a152f63492d301456f29bc4.jpeg";